import { Config } from "@config/config";
import ISelect from "@components/forms/ISelect";
import AISelect from "@components/forms/AISelect";
import { useTranslation } from "react-i18next";
import Input from "@components/forms/Input";
import { getRoute } from "@services/axios";
import React from "react";
import { Search } from "lucide-react";

const FormSearch = (props) => {
  const { t } = useTranslation();
  const config = new Config(t);
 
  return (
    <>
      <div className="row">
        <div className="col-md-2 mb-3">
          <ISelect
            id="productType"
            name="productType"
            label={t("product_type")}
            value={props.selectedProductType}
            handleChange={props.setSelectedProductType}
            route={getRoute("autocomplete_product_type")}
          />
        </div>
        <div className="col-md-2 mb-3">
          <ISelect
            id="status"
            name="status"
            label={t("status")}
            value={props.selectedStatus}
            handleChange={props.setSelectedStatus}
            data={config.productStatusOptions()}
          />
        </div>

        <div className="col-md-2 mb-3">
          <AISelect
            selectedValue={props.selectedCountryCode}
            setSelectedValue={props.setSelectedCountryCode}
            label={t("country")}
            route={getRoute("COUNTRIES")}
              height={50}
          />
        </div>
        <div className="col-md-2 mb-3">
          <AISelect
            selectedValue={props.selectedCity}
            setSelectedValue={props.setSelectedCity}
            label={t("city")}
             height={50}
            route={[getRoute("CITIES"), props.selectedCountryCode?.value].join(
              "/"
            )}
          />
        </div>

        <div className="col-md-2 mb-3">
          <Input
            id="searchText"
            name="searchText"
            type="text"
            placeholder={t("search_by_name")}
            value={props.selectInput}
            onChange={props.getSelectInput}
             height={50}
          />
        </div>
        <div className="col-md-2 mb-3 ">
          <button
           
            className="btn-custom w-100 my-0 "
            onClick={() => props.loadData(1)}
            style={{height:"50px"}}
            
          >
            <Search size={20} strokeWidth={1.2} /> {t("search")}
          </button>
        </div>
      </div>
    </>
  );
};

export default FormSearch;
